module.exports = __webpack_public_path__ + "static/media/fal_fal_exc_zon.60094ff9.png";